module.exports = __webpack_public_path__ + "static/media/plusIcon.b1e4e3ce.svg";